import { CloseIcon } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/layout'
import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react'
import React, { useRef } from 'react'
import { IoSearch } from 'react-icons/io5'
import styled from 'styled-components'

const SearchBarWrapper = styled(Box)<{
  minWidth: string
  padding: string
}>`
  padding: ${props => (props.padding ? props.padding : 'none')};
  min-width: ${props => (props.minWidth ? props.minWidth : 'none')};
  width: ${props => (props.minWidth ? props.minWidth : '100%')};
`

const SearchBar = ({
  placeholder,
  searchQuery,
  setSearchQuery,
  padding,
  minWidth,
  showSearchIcon,
}: {
  placeholder?: string
  padding?: string
  minWidth?: string
  searchQuery: string
  showSearchIcon?: boolean
  setSearchQuery(searchQuery: string): void
}): React.ReactElement => {
  const inputRef = useRef<HTMLInputElement>(null)
  return (
    <SearchBarWrapper padding={padding} minWidth={minWidth}>
      <InputGroup backgroundColor="appWhite">
        {showSearchIcon && (
          <InputLeftElement
            pointerEvents="auto"
            onClick={() => {
              inputRef.current?.focus()
            }}
            children={<Icon color="#9DA3AE" boxSize="1.25rem" as={IoSearch} />}
          />
        )}
        <Input
          placeholder={placeholder || 'Search'}
          value={searchQuery}
          ref={inputRef}
          onChange={e => void setSearchQuery(e.target.value)}
        />
        <InputRightElement>
          {searchQuery ? (
            <IconButton
              aria-label="Clear Search"
              icon={<CloseIcon />}
              colorScheme="appBattleshipGrey"
              variant="link"
              size="xs"
              onClick={() => {
                if (inputRef.current) {
                  inputRef.current.value = ''
                }
                setSearchQuery('')
              }}
            />
          ) : null}
        </InputRightElement>
      </InputGroup>
    </SearchBarWrapper>
  )
}

export default SearchBar
